// extracted by mini-css-extract-plugin
export var container = "_5l-1";
export var cornerButtonContainer = "_5l-6";
export var disabled = "_5l-2";
export var dragActive = "_5l-3";
export var fileContainer = "_5l-5";
export var hiddenInput = "_5l-4";
export var widthContainer = "_5l-0";